<script lang="ts">
</script>
<div class="hero full-height {$$restProps.class}">
    <div class="hero-content text-center">
        <div class="max-w-md">
            <slot />
        </div>
    </div>
</div>
